import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  stage: [],
  allStages: [],
  loading: false,
  // NEW: Specific loading state for document uploads
  documentLoading: false,
  totalCollected: 0,
};

const projectProgressSlice = createSlice({
  name: 'projectProgress',
  initialState,
  reducers: {
    setAllStages: (state, action) => {
  state.allStages = action.payload;
},
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setStages: (state, action) => {
      const existingProjectIndex = state.stage.findIndex(p => p.projectId === action.payload.projectId);

      
      if (existingProjectIndex !== -1) {
        state.stage[existingProjectIndex].stages = action.payload.stages;
      } else {
        state.stage.push({ projectId : action.payload.projectId, stages:action.payload.stages });
  }
},
setTotalCollected: (state, action) => {
      state.totalCollected = action.payload;
    },
    addStage: (state, action) => {
      const { projectId, stage } = action.payload;
      const projectProgress = state.stage.find(p => p.projectId === projectId);

      const newStage = {
        ...stage,
        id: stage.id || stage._id || `temp-${Date.now()}`,
        paid: Number(stage.paid) || 0,
        status: stage.status || "Pending"
      };

      if (projectProgress) {
        projectProgress.stages.push(newStage);
      } else {
        state.stage.push({ projectId, stages: [newStage] });
      }
    },

    recordStagePayment: (state, action) => {
      const { projectId, stageId, paid,payment_date,payment_mode,payment_status } = action.payload;
      const projectProgress = state.stage.find(p => p.projectId === projectId);

      if (projectProgress) {
        const stage = projectProgress.stages.find(s => (s.id === stageId || s._id === stageId));
        if (stage) {
          const incoming = Number(paid) || 0;
          const currentPaid = Number(stage.paid) || 0;
          const stageGoal = Number(stage.amount) || 0;
          
          stage.payment_date = payment_date;
          stage.payment_mode = payment_mode;
          stage.payment_status = payment_status;
          stage.paid = Math.min(stageGoal, currentPaid + incoming);
          stage.status = stage.paid >= stageGoal ? "Completed" : "In Progress";
        }
      }
    },

    deleteDocumentSuccess: (state, action) => {
      const { projectId, stageId } = action.payload;
      const projectProgress = state.stage.find((p) => p.projectId === projectId);
      
      if (projectProgress) {
        const stage = projectProgress.stages.find((s) => s.id === stageId);
        if (stage) {
          // Clear the document path in the state
          stage.documentPath = null; 
          // If you store multiple documents in an array:
          // stage.documents = []; 
        }
      }
    },


    // --- UPDATED DOCUMENT ACTIONS ---

    // 1. Call this BEFORE the API request starts
    startDocumentUpload: (state) => {
      state.documentLoading = true;
    },

    // 2. Call this after the API request succeeds
    recordDocument: (state, action) => {
      const { projectId, stageId, data } = action.payload;
      state.documentLoading = false; // Reset loading

      const project = state.stage.find((p) => String(projectId) === String(p.projectId));
      if (project) {
        const stage = project.stages.find((s) => 
          String(s.id) === String(stageId) || String(s._id) === String(stageId)
        );
        if (stage) {
          stage.documentPath = data.file_path;
        }
      }
    },

    // 3. Call this if the upload fails
    uploadDocumentError: (state) => {
      state.documentLoading = false;
    },

updateStageStatus: (state, action) => {
  const { projectId, stageId, status } = action.payload;
  
  const projectProgress = state.stage.find(p => String(p.projectId) === String(projectId));

  if (projectProgress) {
    const stage = projectProgress.stages.find(s => 
      String(s.id) === String(stageId) || String(s._id) === String(stageId)
    );
    
    if (stage) {
      stage.status = status;
    }
  }
},
  },

  deleteProjectStages: (state, action) => {
  const projectId = action.payload;
  // Filter out the project entry that matches the deleted ID
  state.stage = state.stage.filter(p => String(p.projectId) !== String(projectId));
},
});

export const { 
  setLoading,
  addStage, 
  recordStagePayment, 
  setStages, 
  recordDocument, 
  startDocumentUpload, 
  setTotalCollected,
  uploadDocumentError,
  setAllStages,
  deleteDocumentSuccess,updateStageStatus
} = projectProgressSlice.actions;

export default projectProgressSlice.reducer;